<template>
  <div id='websiteFooter'>
    <cookie-law theme="dark-lime" style="height: 48px">
      <div slot="message">
        This website uses cookies to ensure you get the best experience on our website.
        <router-link to="/datenschutz">Click here</router-link>
      </div>
    </cookie-law>
    <div class="divider"></div>
    <div class="footerContainer">
       <div class="hide-on-large-only divider"></div>
        <div class="footer-copyright" 
            style="font-size: 16px; height: 60px; padding: 10px; background-color: #292929">
          <span style="color: #F0F0F0"> © SmartX Elements 2020 </span>
          <router-link to="/impressum" style="font-size: 16px; padding-left: 10px; color: #F0F0F0"> {{ $t('websiteFooter.imprint') }} </router-link> 
          <router-link to="/datenschutz" class="hide-on-med-and-down right" style="font-size: 16px; padding-left: 10px; color: #F0F0F0"> {{ $t('websiteFooter.dataProtection') }} </router-link>
          <router-link to="/datenschutz" class="hide-on-large-only" style="font-size: 16px; padding-left: 10px; color: #F0F0F0"> {{ $t('websiteFooter.dataProtection') }} </router-link>
        </div>
    </div>
  </div>
  
</template>

<script>
import CookieLaw from 'vue-cookie-law'
export default {
    name: 'websiteFooter',
    components: { CookieLaw }
}
</script>